/**
 * Màu thanh tỷ lệ thắng — Tailwind không dựng được vì đây là `style` nội tuyến
 * (bề rộng thanh cũng tính theo %). Giá trị khớp token `success`/`warning`/
 * `danger`/`ink-muted` trong `tailwind.config.ts`.
 */
const WIN_RATE_BANDS = [
  { min: 50, color: '#22c55e' },
  { min: 30, color: '#f59e0b' },
  { min: 0, color: '#ef4444' },
] as const;

/** Chưa có ván nào — không tô màu thắng/thua cho một tỷ lệ chưa tồn tại. */
export const NO_DATA_COLOR = '#94a3b8';

export function winRateColor(rate: number): string {
  return WIN_RATE_BANDS.find((band) => rate >= band.min)?.color ?? NO_DATA_COLOR;
}
